<a href="#"
   #Filter
   class="k-grid-filter"
   [ngClass]="(isFilterActive() ? 'k-state-active' : '')"
   (click)="show = !show;false">
  <kendo-svg-icon [icon]="ApKendoIconService.Get('filterSmallIcon')"></kendo-svg-icon>
</a>
<kendo-popup #pop
             [anchor]="Filter"
             (anchorViewportLeave)="show = false"
             *ngIf="show">
  <div class="ap-cr-filter k-filter-menu-container">
    <ng-container *ngIf="filterType === filterTypes.MULTI_SELECT">
      <kendo-multiselect [data]="filteredSource"
                         [class.dark-bg]="true"
                         [valuePrimitive]="true"
                         [filterable]="true"
                         (filterChange)="handleFilter($event)"
                         [(ngModel)]="selected"
                         [disabled]="distinctSource.length < 1"
      ></kendo-multiselect>
    </ng-container>
    <ng-container *ngIf="filterType === filterTypes.RANGE">
      <ap-number-filter [currentFilter]="recentNumberFilter"
                        (filterChanged)="numberFilterChanged($event)"
                        [key]="key"
                        [format]="''"
                        [items]="source">
      </ap-number-filter>
    </ng-container>
  </div>
  <div class="k-action-buttons k-button-group">
    <button class="k-button k-primary"
            (click)="processFilter()"
            [disabled]="ProcessFilterDisabled"
    >{{'kendo.grid.filterFilterButton' | translate}}</button>
    <button class="k-button"
            (click)="clearFilter()"
    >{{'kendo.grid.filterClearButton' | translate}}</button>
  </div>
</kendo-popup>
